import type { KpiSnapshot } from './kpiRollup';
import styles from '../../pages/DashboardPage.module.css';

type Props = { snapshots: KpiSnapshot[] };

const CHART_H = 96;
const BAR_W = 5;
const GAP = 6;
const COL_W = BAR_W * 2 + 2;

export function KpiTrendChart({ snapshots }: Props) {
  if (snapshots.length === 0) {
    return (
      <p className={styles.muted}>
        Nog geen dagelijkse KPI-snapshots. Na de eerste nachtelijke run of backfill verschijnen
        trends hier.
      </p>
    );
  }

  const maxVal = Math.max(
    1,
    ...snapshots.flatMap((s) => [s.metrics.leads_new, s.metrics.mails_sent]),
  );

  const width = snapshots.length * (COL_W + GAP) + GAP;
  const height = CHART_H + 28;

  return (
    <div className={styles.chartWrap}>
      <svg
        className={styles.chartSvg}
        width={width}
        height={height}
        role="img"
        aria-label="Trend leads nieuw en mail verzonden"
      >
        {snapshots.map((s, i) => {
          const x = GAP + i * (COL_W + GAP);
          const leadsH = (s.metrics.leads_new / maxVal) * CHART_H;
          const mailH = (s.metrics.mails_sent / maxVal) * CHART_H;
          const label = s.snapshot_date.slice(5);
          return (
            <g key={s.snapshot_date}>
              <rect
                x={x}
                y={CHART_H - leadsH}
                width={BAR_W}
                height={Math.max(leadsH, s.metrics.leads_new > 0 ? 2 : 0)}
                className={styles.chartSvgLeads}
              >
                <title>{`${s.snapshot_date} — leads nieuw: ${s.metrics.leads_new}`}</title>
              </rect>
              <rect
                x={x + BAR_W + 2}
                y={CHART_H - mailH}
                width={BAR_W}
                height={Math.max(mailH, s.metrics.mails_sent > 0 ? 2 : 0)}
                className={styles.chartSvgMail}
              >
                <title>{`${s.snapshot_date} — verzonden: ${s.metrics.mails_sent}`}</title>
              </rect>
              <text x={x + COL_W / 2} y={CHART_H + 14} className={styles.chartSvgLabel}>
                {label}
              </text>
            </g>
          );
        })}
      </svg>
      <div className={styles.chartLegend}>
        <span>
          <i className={styles.legendLeads} /> Leads nieuw
        </span>
        <span>
          <i className={styles.legendMail} /> Mail verzonden
        </span>
      </div>
    </div>
  );
}
